/* eslint-disable prettier/prettier, camelcase */
import { v4 as uuidV4 } from "uuid";

export const QUERY = {
  allEngineers: `
  query MyQuery {
    allEngineers(condition:{isActive: true}){
       nodes{
        id
        value:id
        label:firstName
        firstName
        lastName
        email
        isActive
        createdAt
        updatedBy
      }
    }
  }
    `,
  allUser: (roleId = 3) => `
    query MyQuery {
        allUserProfiles(condition: {roleId: ${roleId}, isActive:true}) {
          nodes {
            id
            value:id
            label:firstName
            name:firstName
            last_name:lastName
            email_id:emailId
            emailId
            firstName
            lastName
            country
            masterCountryByCountryId{
              id
              countryName
            }
            img:profilePic
            designation: masterRoleByRoleId{
              roleName
            }
          }
        }
      }
    `,
  addEngineer: ({ name: firstName, last_name: lastName, email_id: emailId }) => {
    return `
  mutation{
    createEngineer(input:{
      engineer:{
        id:"${uuidV4()}",
        firstName:"${firstName}",
        lastName:"${lastName}",
        email:"${emailId}",
        isActive:true,
        createdAt: "${new Date().toISOString()}"
        updatedAt: "${new Date().toISOString()}"
      }
    }){
      clientMutationId
    }
  }
    `
  },
  updateEngineer: ({ id, isActive = true, name, last_name, country = '', country_id }) => `
  mutation MyQuery {
    updateUserProfileById(
      input: { userProfilePatch: { firstName: "${name}", lastName: "${last_name}", isActive: ${isActive}, country: "${country}", ${country_id ? `countryId: ${country_id}` : ``} }, id: "${id}" }
    ) {
      clientMutationId
    }
  }`
};